/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierPaymentStrategy {
  EmailAskingToChargeCardOnFile = "EmailAskingToChargeCardOnFile",
  PayByCheque = "PayByCheque",
  BatchPayByCheque = "BatchPayByCheque",
  BatchPayByEft = "BatchPayByEFT",
  TheyAutoChargeOurCreditCard = "TheyAutoChargeOurCreditCard",
  Manual = "Manual",
}

export function instanceOfCarrierPaymentStrategy(value: any): boolean {
  for (const key in CarrierPaymentStrategy) {
    if (Object.prototype.hasOwnProperty.call(CarrierPaymentStrategy, key)) {
      if (
        CarrierPaymentStrategy[key as keyof typeof CarrierPaymentStrategy] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierPaymentStrategyFromJSON(
  json: any,
): CarrierPaymentStrategy {
  return CarrierPaymentStrategyFromJSONTyped(json, false);
}

export function CarrierPaymentStrategyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierPaymentStrategy {
  return json as CarrierPaymentStrategy;
}

export function CarrierPaymentStrategyToJSON(
  value?: CarrierPaymentStrategy | null,
): any {
  return value as any;
}

export function CarrierPaymentStrategyToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierPaymentStrategy {
  return value as CarrierPaymentStrategy;
}
